<template lang="pug">
.other-office-connection-message-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：登録情報
    template(#cell(operation)="row")
      button.btn.detail-btn(@click="onDetail(row.item)" style="position: relative;") 詳細
        .sidemenu-badge
          b-badge(v-if="row.item.unreadCount && 0 < row.item.unreadCount" pill variant="sidemenu-badge") {{ row.item.unreadCount }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { OtherOfficeConnectionGetModel } from "@/commons/services/OtherOfficeConnections";

/**
 * 利用者テーブルコンポーネント
 */
@Component({})
export default class OtherOfficeConnectionTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OtherOfficeConnectionTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OtherOfficeConnectionTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<OtherOfficeConnectionTableItem> {
    return this.value;
  }

  public convertDatetime(datetime: number): string {
    if (datetime) {
      return this.$dateUtil.convertNumberToString(datetime, "yyyy/mm/dd hh:MM");
    } else {
      return "";
    }
  }

  /**
   * ### フィルタリング
   */
  public filterTable(row: OtherOfficeConnectionTableItem, filter: FilterSetting): boolean {
    return this.filterSearchWords(row, filter);
  }

  public filterSearchWords(row: OtherOfficeConnectionTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundOfficeName: boolean = true;
    let foundStaffName: boolean = true;

    for (const word of words) {
      if (row.officeName.indexOf(word) == -1) {
        foundOfficeName = false;
      }
      if (row.staffName.indexOf(word) == -1) {
        foundStaffName = false;
      }
    }

    return foundOfficeName || foundStaffName;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  public onDetail(item: OtherOfficeConnectionTableItem): void {
    this.$emit("onDetail", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface OtherOfficeConnectionTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface OtherOfficeConnectionTableItem extends OtherOfficeConnectionGetModel {
  /** 未読の投稿数 */
  unreadCount?: number;
}

export interface FilterSetting {
  /** 検索ワード */
  searchWord: string;
}
</script>

<style lang="scss" scoped>
.other-office-connection-message-table-component {
  .detail-btn,
  .edit-btn,
  .resend-btn {
    width: 94px;
  }
  .sidemenu-badge {
    position: absolute;
    top: -8px;
    right: -12px;
    width: 32px;
    z-index: 1001;

    .sidemenu-badge-content {
      width: 3px;
      height: 10px;
    }
  }
}
</style>
